/**
 * Helpers de rol para el frontend. Mirror de `isPlatformAdmin` del backend:
 * `platform_super` (operador de plataforma Booster) tiene los poderes de
 * `platform_admin` + cross-tenant, así que NO debe quedar excluido de los checks
 * de admin de la UI.
 */
export function isPlatformAdminRole(role?: string | null): boolean {
  return role === 'tenant_admin' || role === 'booster_admin';
}

/**
 * Cuentas en las que NADIE puede entrar con "ingresar como".
 *
 * Espejo de `isImpersonationProtected` del backend, que es el que manda. Son las cuentas
 * de PLATAFORMA: `booster_admin` y `booster_support`. Es un agujero ya cerrado: el admin
 * de una inmobiliaria podía entrar como `soporte@imperium.uy` y quedarse con una sesión de
 * soporte, que es CROSS-TENANT —ve bugs, analítica y charlas de Gustavo de TODOS los
 * tenants—. Un rol de tenant no puede ser la puerta a un rol de plataforma.
 *
 * `tenant_admin` NO está acá: es el dueño de una inmobiliaria, y a él sí entra el staff de
 * plataforma. Quién puede, lo decide `puedeEntrarComo`. (18/08/2026)
 */
export function isImpersonationProtectedRole(role?: string | null): boolean {
  return role === 'booster_admin' || role === 'booster_support';
}

/**
 * ¿`actorRole` puede entrar como `targetRole`? Espejo de `canImpersonate` del backend.
 *
 * Vive acá y no suelto en la pantalla porque las dos formas de equivocarse duelen: si el
 * botón se esconde de más, soporte no puede reproducir el bug que le reportaron; si se
 * muestra de más, el usuario aprieta y se come un 403.
 */
export function puedeEntrarComo(
  actorRole: string | undefined | null,
  targetRole: string,
  mismaOficina = true,
): boolean {
  if (isImpersonationProtectedRole(targetRole)) return false;
  const esStaff = actorRole === 'booster_admin' || actorRole === 'booster_support';
  // Al DUEÑO de una cuenta solo entra el staff de plataforma: un tenant_admin entrando
  // como otro sería saltar de una inmobiliaria a otra.
  if (isPlatformAdminRole(targetRole) && !esStaff) return false;
  if (actorRole === 'office_admin') {
    if (targetRole === 'office_admin') return false;
    if (!mismaOficina) return false;
  }
  return true;
}
